import { render, staticRenderFns } from "./ChangeBillValueModal.vue?vue&type=template&id=387dff32&"
import script from "./ChangeBillValueModal.vue?vue&type=script&lang=js&"
export * from "./ChangeBillValueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports